// extracted by mini-css-extract-plugin
export default {"wishlistSection":"WishlistSection_wishlistSection__-tiF5","emptyWishlist":"WishlistSection_emptyWishlist__CL4iw"};